import React from 'react';
import './InfoOrganizerPage.scss';
import Spinner from 'Components/Shared/Spinner/Spinner';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';

interface IProps {
  isFetching: boolean;
  content: Julius.Website.OrganizerPageViewModel;
}

const InfoOrganizerPage: React.SFC<IProps> = ({
  isFetching,
  content,
}) => {

  if (isFetching) {
    return <Spinner height='lg' />
  }

  if (!content) {
    return null;
  }

  return (
    <WrapperLayout style='info-organizer-page' padding='xl'>
      <div className='title'>{ content.title }</div>
      <div dangerouslySetInnerHTML={ { __html: content.text } } />
    </WrapperLayout>
  );
};

export default InfoOrganizerPage;


// WEBPACK FOOTER //
// ./src/pages/InfoOrganizerPage/InfoOrganizerPage.tsx